import $ from 'jquery';
import Cookies from 'js-cookie';

// When a user visits an ARK URL, set the MetaID of the object in localStorage so that subsequent
// search results are annotated.
function setArkHistory() {
    if ($('body.ark').length) {
        const metaID = $('body').data('meta-id');
        sessionStorage.setItem(`ark-${metaID}`, metaID);
    }
}

function getArkHistory(options) {
    if ($('body.results').length) {
        $(options.selector).each(function () {
            const $this = $(this);
            const metaID = $this.data('meta-id');
            const $seen = $('<i>', {
                    class: 'fa  fa-check  sup',
                    title: 'Previously viewed this session.',
                    'data-toggle': 'tooltip',
                });

            if (sessionStorage.getItem(`ark-${metaID}`)) {
                $this.parent().append($seen);
            }
        });
    }
}

// Set Cookie when user clicks a search result link to ARK. Subsequently read in template to
// remember scroll position
function setSearchResultScrollPosition() {
    if ($('body.results').length) {
        $('#main-section').find('.result a').on('click', function () {
            const $thisResult = $(this).closest('article.result').attr('id');
            Cookies.set('aubreyBackToResult', $thisResult);
        });
    }
}

export {
    setArkHistory,
    getArkHistory,
    setSearchResultScrollPosition,
};
